import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchSummaryScore } from '@apis/performance';
import type { ScoreApiData } from '@app-types/summaryApi';
import { getAccessToken } from '@utils/authStorage';
import { getIframeQueryParamsFromSearch } from '@utils/queryParams';

/**
 * React Query hook for the Enterprise Score (GET /api/summary/score).
 * Reads ticker/mkt from the router location so URL changes refetch.
 */
export const useSummaryScore = () => {
  const location = useLocation();
  const { ticker, mkt } = getIframeQueryParamsFromSearch(location.search);
  const hasToken = Boolean(getAccessToken());

  return useQuery<ScoreApiData>({
    queryKey: ['summary', 'score', ticker, mkt],
    queryFn: () => fetchSummaryScore({ ticker: ticker as string, mkt: mkt as string }),
    enabled: Boolean(ticker && mkt && hasToken),
    staleTime: 60_000,
    retry: 1,
  });
};
